import { useQuery } from "@tanstack/react-query";
import fetchToBackend, { buildQuery } from "@/utils/fetchToBackend";
import { profileItemKeys } from "@/lib/query-keys";
import type { ProfileItem } from "@/types/domain";

export function useProfileItems(searchProfileId?: number) {
  return useQuery({
    queryKey: profileItemKeys.byProfile(searchProfileId),
    enabled: searchProfileId != null,
    queryFn: async () => {
      const query = buildQuery({ searchProfileId });
      const res = await fetchToBackend<any>(`/searchprofileitems/getAll${query}`);
      return (res?.data ?? res ?? []) as ProfileItem[];
    },
  });
}
